import Groceries from "../Groceries/Groceries";
const Grocery = () => {
  return <Groceries />;
};

export default Grocery;
